// src/content/services.js
import {
  ShoppingCartIcon,
  CodeBracketIcon,
  GlobeAltIcon,
  MagnifyingGlassIcon,
  ServerIcon,
  WrenchScrewdriverIcon,
  ArrowsRightLeftIcon,
} from '@heroicons/react/24/outline';

// The order here must match the order in your translation.json "tab_items" array
export const serviceConfig = [
  {
    id: 'magento',
    icon: ShoppingCartIcon,
    stack: ['Magento 2', 'Hyvä', 'Elasticsearch', 'Redis', 'Varnish', 'RabbitMQ'],
    landingPath: '/ecommerce-development',
    etLandingPath: '/e-poe-tegemine'
  },
  {
    id: 'website',
    icon: GlobeAltIcon,
    stack: ['Astro', 'React', 'Tailwind CSS', 'Node.js', 'Nginx'],
    landingPath: '/website-development',
    etLandingPath: '/kodulehe-tegemine'
  },
  {
    id: 'custom-dev',
    icon: CodeBracketIcon,
    stack: ['React', 'Node.js', 'Laravel', 'PostgreSQL', 'Docker']
  },
  {
    id: 'audit',
    icon: MagnifyingGlassIcon,
    stack: ['Blackfire', 'New Relic', 'K6', 'Lighthouse', 'Security Headers']
  },
  {
    id: 'servers',
    icon: ServerIcon,
    stack: ['AWS', 'Hetzner', 'Ubuntu', 'Nginx', 'Bash/Shell', 'CI/CD']
  },
  {
    id: 'modernization',
    icon: WrenchScrewdriverIcon,
    stack: ['Strangler Fig', 'Microservices', 'API Gateway', 'Legacy PHP']
  },
  {
    id: 'integration',
    icon: ArrowsRightLeftIcon,
    stack: ['REST API', 'GraphQL', 'SOAP', 'Erply', 'Directo', 'Standard Books'],
    landingPath: '/erp-integration',
    etLandingPath: '/erp-integratsioon'
  }
];
